import { render, staticRenderFns } from "./indexset.vue?vue&type=template&id=79b8a2cf&scoped=true&"
import script from "./indexset.vue?vue&type=script&lang=js&"
export * from "./indexset.vue?vue&type=script&lang=js&"
import style0 from "./indexset.vue?vue&type=style&index=0&id=79b8a2cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b8a2cf",
  null
  
)

export default component.exports